import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorBoundary } from '../../../__generated__/fail-safe/ErrorBoundary';
import { MarketplaceListingCTAButton } from 'marketplace-ui-install/install/MarketplaceListingCTAButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function renderCardButtons({
  buttons,
  listing
}) {
  var _buttons$primary, _buttons$secondary;
  const primaryButton = buttons === null || buttons === void 0 || (_buttons$primary = buttons.primary) === null || _buttons$primary === void 0 ? void 0 : _buttons$primary.find(b => conditionMet(b, listing));
  const secondaryButton = buttons === null || buttons === void 0 || (_buttons$secondary = buttons.secondary) === null || _buttons$secondary === void 0 ? void 0 : _buttons$secondary.find(b => conditionMet(b, listing));
  const result = [];
  if (primaryButton) {
    if ('isManaged' in primaryButton) {
      result.push( /*#__PURE__*/_jsx(ErrorBoundary, {
        onError: (error, errorInfo) => {
          console.error('CardButtons_MarketplaceListingCTAButton', {
            error,
            errorInfo
          });
        },
        children: /*#__PURE__*/_jsx(MarketplaceListingCTAButton, {
          appContext: "app",
          isEmbedded: true,
          slug: listing.slug,
          size: "small",
          onClick: () => {
            var _primaryButton$onClic;
            (_primaryButton$onClic = primaryButton.onClick) === null || _primaryButton$onClic === void 0 || _primaryButton$onClic.call(primaryButton, {
              close: () => {},
              listingId: String(listing.listingId),
              slug: listing.slug,
              sourceId: listing.products[0].sourceId
            });
          }
        })
      }, "primary"));
    } else {
      result.push( /*#__PURE__*/_jsx(CustomButton, {
        button: primaryButton,
        listing: listing,
        use: "primary"
      }, "primary"));
    }
  }
  if (secondaryButton) {
    result.push('isManaged' in secondaryButton ? /*#__PURE__*/_jsx(Button, {
      onClick: () => {
        var _secondaryButton$onCl;
        (_secondaryButton$onCl = secondaryButton.onClick) === null || _secondaryButton$onCl === void 0 || _secondaryButton$onCl.call(secondaryButton, {
          close: () => {},
          listingId: String(listing.listingId),
          slug: listing.slug,
          sourceId: listing.products[0].sourceId
        });
      },
      size: "small",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-embed.card.learnMore"
      })
    }, "secondary") : /*#__PURE__*/_jsx(CustomButton, {
      button: secondaryButton,
      listing: listing,
      use: "transparent"
    }, "secondary"));
  }
  return result;
}
function CustomButton({
  button,
  listing,
  use
}) {
  return /*#__PURE__*/_jsx(Button, {
    external: button.external,
    href: button.href,
    onClick: () => {
      var _button$onClick;
      return (_button$onClick = button.onClick) === null || _button$onClick === void 0 ? void 0 : _button$onClick.call(button, {
        // This is a no-op because if the card is being rendered directly,
        // outside of our modals, then there's no modal to close (duh).
        // If we ARE in a modal, the actual `close` functionality will
        // be provided by `useMarketplaceModal`. Ideally we'd have separate
        // button type definitions for in-modal vs. standalone.
        close: () => {},
        listingId: String(listing.listingId),
        slug: listing.slug,
        sourceId: listing.products[0].sourceId
      });
    },
    size: "small",
    use: use,
    children: button.label
  });
}
function conditionMet(button, listing) {
  var _listing$products$;
  const {
    condition
  } = button;

  // unconditional - always show
  if (!condition) return true;
  if (condition.installed && !((_listing$products$ = listing.products[0]) !== null && _listing$products$ !== void 0 && _listing$products$.installed)) return false;
  if (condition.slug && !condition.slug.includes(listing.slug)) return false;

  // all conditions met!
  return true;
}